// TODO Use Kotlin code

const JANUARY = 0;
const JULY = 6;
const DECEMBER = 11;

const quarterStarts = [
  new Date(Date.UTC(2000, JANUARY, 1)),
  new Date(Date.UTC(2000, JANUARY + 3, 1)),
  new Date(Date.UTC(2000, JANUARY + 6, 1)),
  new Date(Date.UTC(2000, JANUARY + 9, 1)),
];

export const OSS_START_DATE = new Date(Date.UTC(2021, JULY, 1));

let MOCK_DATE: Date = null;
export function now() {
  return MOCK_DATE ?? new Date();
}
export function setNow(nowDate) {
  MOCK_DATE = nowDate;
}

export function nextCommencementDate(nowDate: Date) {
  // max between OSS start date and the next quarter's start date
  const nextQuarterStartDt = nextQuarterStartDate(nowDate);
  return nextQuarterStartDt.getTime() > OSS_START_DATE.getTime()
    ? nextQuarterStartDt
    : OSS_START_DATE;
}

export function importStartDate(now: Date) {
  // max between OSS start date and today (a prediction of the date in which the MSID takes the decision to approve the registration)
  const predictedApprovalDate = nowDate(now);
  return predictedApprovalDate.getTime() > OSS_START_DATE.getTime()
    ? predictedApprovalDate
    : OSS_START_DATE;
}

export function nextQuarterStartDate(nowDate: Date) {
  // find first quarter start after nowDate in the same year
  for (const quarterStart of quarterStarts) {
    const currYearQuarterStart = new Date(quarterStart);
    currYearQuarterStart.setFullYear(nowDate.getFullYear());
    if (currYearQuarterStart.getTime() > nowDate.getTime()) {
      return currYearQuarterStart;
    }
  }
  // otherwise return the first quarter of next year
  const nextYearFirstQuarterStart = new Date(quarterStarts[0]);
  nextYearFirstQuarterStart.setFullYear(nowDate.getFullYear() + 1);
  return nextYearFirstQuarterStart;
}

export function nextMonthStartDate(nowDate: Date) {

  if (nowDate.getMonth() === DECEMBER) {
    return new Date(Date.UTC(nowDate.getUTCFullYear() + 1, JANUARY, 1));

  } else {
    return new Date(Date.UTC(nowDate.getUTCFullYear(), nowDate.getUTCMonth() + 1, 1));

  }

}

export function nowDate(now: Date) {
  return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
}
